import api from '@/utils/api';

/**
 * Get all users
 * @param {string} filter - filter
 * @returns {Promise}
 */
const getUserRolesApi = (filter) => api.get(`user-role?${filter}`);

export default getUserRolesApi;
